import { render } from "./salesgrowthchart.vue?vue&type=template&id=6a1c9c7e&scoped=true&lang=true"
import script from "./salesgrowthchart.vue?vue&type=script&lang=js"
export * from "./salesgrowthchart.vue?vue&type=script&lang=js"

import "./salesgrowthchart.vue?vue&type=style&index=0&id=6a1c9c7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1c9c7e"]])

export default __exports__